function ResponseTransformer (responses) {
    if(responses == undefined) {
        responses = [];
    }

    return responses;
}

export default ResponseTransformer;